<template>
    <div class="download max-content">
        <van-nav-bar title="往期回顾" left-arrow @click-left="onClickLeft" />
        <div class="list">

            <div @click="navto(item)" v-for="(item, index) in eposters" :key="index">
                <img :src="item.share_pic?item.share_pic:item.banner" alt="">
                <p>{{ item.name }}</p>

            </div>

        </div>
        <!-- <img src="@/assets/images/cvscf2023/bottom.png" class="bottom"/> -->
    </div>
</template>

<script>
import { Eposters } from '@/config/interface.js'
import Top from '../VascularSystem/components/Top.vue'
export default {
    components: {
        Top
    },
    created() {
        this.button_id = this.$route.query.button_id ? this.$route.query.button_id : this.$route.query.b_id;

    },
    data() {
        return {    //轮播图
            eposters: [],
            meeting_id: this.$route.query.meeting_id ? this.$route.query.meeting_id : this.$route.query.MT_id,
        }
    },
    mounted() {
        this.getPosters();
    },
    methods: {
        onClickLeft() {
            this.$router.go(-1)
        },
        getPosters() {
            const url = Eposters;
            let params = {
                meeting_id: this.meeting_id
            }
            const method = 'POST';
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        let data = res.data;
                        this.eposters = data;
                    }
                })
        },
        navto(item) {
            window.location.href = item.bind_url;

        }
    }
}
</script>

<style lang="scss" scoped>
.van-nav-bar {
    background: #d8261d;

    .van-icon {
        color: white;
    }
}

.van-nav-bar /deep/.van-icon {
    color: white;
}

.van-nav-bar /deep/.van-nav-bar__title {
    color: white;
    font-size: 16px;
    letter-spacing: 0.5px;
}

.list {
    width: 100%;
    padding: 0 15px;

    >div {
        width: 100%;
        padding: 20px 0;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e5e5e5;

        img {
            width: 60px;
            // height: 80px;
            border-radius: 5px;
            margin-right: 10px;
            flex-shrink: 0;
            display: block;
            // background-color: #d8261d;
        }

        p {
            flex: 1;
            font-size: 14px;
            font-weight: 500;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            line-clamp: 2;
            max-height: 40px;
            overflow: hidden;
            text-overflow: ellipsis;


        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/XVC/history.vue